module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"sendToFortus":"Send to Fortus","sendToCRM":"Send to CRM"},"fr":{"sendToFortus":"Envoyer à Fortus","sendToCRM":"Envoyer au CRM"}}')
  delete Component.options._Ctor
}
